var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Button, Card, Collapsible, Typography } from '@airtel/air-design-system';
import { withBoundaries } from '../../hoc';
import { getAccordionSectionStyles } from './AccordionSectionStyles';
var AccordionSectionComponent = props => {
  var accordionSectionStyles = getAccordionSectionStyles();
  var children = props.children,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$titleColor = props.titleColor,
    titleColor = _props$titleColor === void 0 ? BLACK_700 : _props$titleColor,
    _props$hideIcon = props.hideIcon,
    hideIcon = _props$hideIcon === void 0 ? false : _props$hideIcon,
    onPress = props.onPress,
    onCtaPress = props.onCtaPress,
    ctaText = props.ctaText,
    id = props.id,
    onUserAction = props.onUserAction,
    style = props.style,
    restProps = __rest(props, ["children", "title", "titleColor", "hideIcon", "onPress", "onCtaPress", "ctaText", "id", "onUserAction", "style"]);
  return _jsx(Card, Object.assign({
    noPadding: true,
    style: [accordionSectionStyles.cardContainer, style]
  }, restProps, {
    children: _jsxs(Collapsible, Object.assign({
      titleComponent: !!title && _jsx(Typography, {
        text: title,
        type: "body-single-line-sm-bold",
        color: titleColor
      }),
      showIcon: !hideIcon,
      version: "variable-width",
      onToggleHandler: isExpanded => {
        onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onPress), {
          isExpanded
        }));
      }
    }, {
      children: [children, !!ctaText && _jsx(Button, {
        title: ctaText,
        buttonType: "tertiary",
        style: accordionSectionStyles.button,
        onPress: () => {
          onCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onCtaPress)));
        }
      })]
    }))
  }));
};
AccordionSectionComponent.genericRendererKey = 'AirAccordionSection';
AccordionSectionComponent.isAirSection = true;
export var AccordionSection = withBoundaries(AccordionSectionComponent);